import * as React from 'react';
import { Redirect } from 'react-router';
import { paths } from '../../app/constants';
import { trackEvent } from '../../analytics';

interface ErrorBoundaryState {
    hasError: boolean,
} 

export interface ErrorBoundaryStateProps {
}

export interface ErrorBoundaryDispatchProps {
    onError: (error: Error, errorInfo: React.ErrorInfo) => void;
}

export type ErrorBoundaryProps = ErrorBoundaryStateProps & ErrorBoundaryDispatchProps;

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        if (
            location.search.includes('disable-error-boundary') ||
            location.search.includes('headless') ||
            location.hostname === 'localhost'
        ) return;
        trackEvent('error_boundary', {
            error: error.message,
            component: errorInfo.componentStack?.trim().split('\n')[0] ?? '',
        });
        this.setState({ hasError: true });
        this.props.onError(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <Redirect to={paths.root()}/>;
        }
        return this.props.children;
    }
}

export default ErrorBoundary